/* Section order.

   Both product templates call {% section %} and then {% render 'luma-ucover' %}, so the
   sections rendered by the snippet land OUTSIDE <div class="lp"> and therefore after
   the footer. "What buyers say" was rendering BELOW the footer, and "Pairs well with"
   needs to sit above the bundle to match the reference site's order:

     ... FAQ -> Pairs well with -> Bundle -> Reviews -> Footer

   Moving them in the DOM is presentation only; all copy stays in Liquid. */
(function(){
function place(){
  var lp=document.querySelector('.lp'); if(!lp) return false;
  var foot=lp.querySelector('.foot');
  var bundle=lp.querySelector('.band.bundle');
  var pairs=document.querySelector('.lpair');
  var revs=document.querySelector('.lrev');
  var done=true;

  /* Pairs well with -> immediately above the bundle (and above its launch bar) */
  if(pairs&&bundle){
    var anchor=lp.querySelector('.lbrep')||bundle;
    if(anchor.previousElementSibling!==pairs) anchor.parentNode.insertBefore(pairs,anchor);
  }else if(!pairs&&bundle){ /* nothing to move - the cross-sell is suppressed */ }
  else done=false;

  /* Reviews -> inside .lp, directly above the footer */
  if(revs&&foot){
    if(foot.previousElementSibling!==revs) foot.parentNode.insertBefore(revs,foot);
  }else if(!revs&&foot){ /* no reviews for this product */ }
  else done=false;

  return done;
}
document.addEventListener('DOMContentLoaded',function(){
  if(place()) return;
  var n=0,iv=setInterval(function(){ n++; if(place()||n>40) clearInterval(iv); },100);
});
window.addEventListener('load',function(){ setTimeout(place,400); });
})();